var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"info_container"},[_c('div',{staticClass:"info"},[_c('i',{staticClass:"el-icon-success"}),_c('h2',[_vm._v("您的已成功下单，订单号："),_c('span',[_vm._v(_vm._s(_vm.id))]),_vm._v("，请您耐心等待后续流程制作。")]),_c('el-link',{on:{"click":function($event){return _vm.back()}}},[_vm._v("[ [ 点此返回首页 ] ]")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }